/* 全局filters引入文件 */
import jeFormat from './jeFormat';
import responsiveMaxHeight from './elementResposive/responsiveMaxHeight';
import computedElementHeight from './elementResposive/computedElementHeight';

export default function injectFilters(Vue) {
	// if(typeof Vue!=='function'|| Vue.name!=='Vue'){
	// 	throw new Error('Vue构造函数类型错误，注册全局过滤器失败！');
	// }
	Vue.filter('jeFormat', jeFormat);
	Vue.filter('responsiveMaxHeight', responsiveMaxHeight);
	Vue.filter('computedElementHeight', computedElementHeight);
}
